export default __webpack_public_path__ + "static/media/ic-mail.a9c024ab.svg";